import React from "react";
import { Logo, Navigation } from "./shared";
import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom"

import "./style.css";

const Header = () => {
  return (
    <header id="header" className="w-100">
      <Navbar bg="transparent" expand="lg">
        <Container fluid className="px-5 mob-px-2">
          <Navbar.Brand as={Link} to="/" className="logo mx-0 py-0">
            <Logo />
          </Navbar.Brand>
          {/* <Navbar.Toggle /> */}
          <Navbar.Toggle aria-controls="header-navbar-nav" className="border-0" />
          <Navbar.Collapse id="header-navbar-nav" className="justify-content-end">
            <Navigation />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
